import {queryClient} from 'infra/libs/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {ContactDataResponse} from 'presentation/services/getContactData/types';

const updateContactDataCache = (partialData: Partial<ContactDataResponse>) => {
	queryClient.setQueryData([QUERY_KEYS.CONTACT_DATA], (oldData: ContactDataResponse) => ({
		...oldData,
		...partialData,
	}));
};

export {updateContactDataCache};
